import Transformer from "../transformer";
import { assetURL } from "@/utils";
import ObjectToForm from "../../utils/objectToForm";
import imagePlaceholder from "@/assets/images/image_placeholder.jpg";

export default class imagesTransformer extends Transformer {
  static fetch({
    id,
    add_date: addDate,
    affected = {},
    date_content: dateContent,
    file,
    file_type = {},
    is_active: isActive,
    size,
    small_photo,
    visible_customer,
  }) {
    const smallPhoto = small_photo ? assetURL(small_photo) : imagePlaceholder;
    return {
      // fileId: files.id,
      affectedRN: affected.affected_requisition_number,

      affectedId: affected.affected_id,
      affectedSinisterNumber: affected.affected_sinister_number,

      fileTypeId: file_type.file_type_id,
      fileTypeName: file_type.file_type_name,
      codename: file_type.file_type_codename,
      fileTypeDescription: file_type.file_type_description,
      fileTypeMaxSize: file_type.file_type_max_size,
      clientVisibility: visible_customer,

      id,
      visibleCustomer: visible_customer,
      file,
      // file: file && assetURL(file),
      smallPhoto,
      isActive,
      dateContent,
      addDate,
      size,
    };
  }

  static send(file) {
    const fd = ObjectToForm(file);
    fd.append("is_active", true);
    fd.append("file_type", file.fileType);
    fd.append("visible_customer", !!file.visibleCustomer);
    if (file.dateContent) {
      fd.append("date_content", file.dateContent);
    }
    return fd;
  }
}

/*
Tabla header fijo en catalogos y todas las tablas, quitar footer de tablas

Querella Interfaz firma: alta de sineistro especificar girma de quien
FIcha de siniestro titulos de rubros asignacion afectado
  mas grandes y en engritas delimitar bloques

  REGISTOR DE SINIESTRO si es querella generar ventana de validacion de correo para solicitar
    documetnos faltantes

  Crear cuantificacion npombre a alcance en dias y el personal necesario
    Poder selcccionar cuantas personas y que rol para integrar nueva cuadrilla a asignacion

Numero de ciniestro
  fix segundo numero debe esta compuesto 3 digitos en caso de 45 es 045

  Indicar en cuantificacion el kilometraje del punto de cmapamento al siniestro y calcular el costo de traslado contanto gasolina
  dar de alta campamentos con direccion y distancia de campamento a la entrada de carretera por constante
    20 km campamento a la entrada de la caretera (30 km campamento) + 58 de distancia (camapmento + entrada carretera)

  Fecha de Cotizacion en Vista de Cotizacion

Compras en proximas versiones neceist aun canva, macroprocesa
  Trello Lineal sobre las ordenes de compra

Colores por area
  FInanzas morado
  administracion verder etc.


VArias casetas por tramo
  No 1 caseta 1 tramo

  Comap;ia carretera
    compa;lia === afectado
    cliente


  afectado es compa;ia carretera
  Delegacion Puebla
  CAPUFE : cliente AXA
  nombre de autopista Puebla-Mexico

  IDEAL
  Afectado es ideal
  delegacion no aplica
  cliente
    arco norte


*/



// WEBPACK FOOTER //
// ./src/transformers/Files/Files.js